export const package1 = {
  imgSrc: "graphics_1.png",
  imgAlt: "Eugene Oasis Business cards in circle.",
  name: "Graphics Package 1",
  description:
    "A complete branding package to Promote Your Place! This includes 1) Full color logo; 2) 1-color logo version; 3) AI and PDF files of both logo formats; 4) Up to 3 revisions. We send a survey to get details on photos and examples of the best themes/fonts/styles to set us off on the right track.",
  price: "$150",
};

export const package2 = {
  imgSrc: "graphics_2.png",
  imgAlt: "Eugene Oasis memo pad and pencil.",
  name: "Graphics Package 2",
  description:
    "One enhanced design for any product. EXISTING LOGO REQUIRED. This is for applications more than a logo is required. Examples might be: A) Custom backgrounds; B) Wallpaper graphics; C) Merchandise with multiple print areas and you wish a different graphic in each location. This includes 1) Virtual sample mock-up; 2) Production art; 3) AI and PDF files of the design 4) Up to 2 revisions We send a survey to get details on photos and examples of the best themes/fonts/styles to set us off on the right track. ",
  price: "$50",
};

export const package3 = {
  imgSrc: "graphics_3.png",
  imgAlt: "Eugene Oasis graphics being designed on a laptop.",
  name: "Graphics Package 3",
  description:
    "Have a piece or art or logo but it’s not print ready, needs to be resized or needs some minor revision? This is your solution. Submit the existing idea/art as a JPG and we deliver 1) A production ready art file in both AI and PDF formats; 2) Up to 2 revisions. ",
  price: "$25",
};
